import React, { useMemo } from "react";

import { Box, SystemStyleObject } from "@chakra-ui/react";

import { Paragraph3, Paragraph4 } from "ui/typography";

import { IBusinessComplianceTabItemProps } from "./types";

const START_INDEX = 0;
const defaultCss = { flex: "0 0 60px" };
const selectedBusinessCss = {
  backgroundColor: "#00535C14",
  borderRadius: "8px",
};

export const BusinessComplianceTabItem = (
  props: IBusinessComplianceTabItemProps
) => {
  const { business, initialsBgColor, handleSelectBusiness, isSelected } = props;

  const handleSelectBusinessToView = () => {
    handleSelectBusiness(business);
  };

  const businessName =
    business.company?.companyName || business.company?.businessName;
  const businessLogo = business.company?.businessLogo;

  const tabItemWrapperCss: SystemStyleObject = useMemo(() => {
    if (!isSelected) {
      return defaultCss;
    }
    return { ...defaultCss, ...selectedBusinessCss };
  }, [isSelected]);

  return (
    <Box
      className="flex h-[60px] py-[5px] px-3 gap-3 items-center cursor-pointer"
      css={tabItemWrapperCss}
      onClick={handleSelectBusinessToView}
    >
      <Box
        className="h-8 w-8 rounded-[50%] flex justify-center items-center"
        css={{
          backgroundColor: `${!businessLogo ? initialsBgColor : ""}`,
          color: `${!businessLogo ? "#ffffff" : ""}`,
          flexShrink: 0,
        }}
      >
        {businessLogo ? (
          <img
            src={businessLogo}
            alt={`${businessName}'s logo`}
            className="w-full h-auto"
          />
        ) : (
          <span className="capitalize text-[12.58px] leading-[19.2px] font-medium text-center">
            {(businessName ?? business.email)?.charAt(START_INDEX)}
          </span>
        )}
      </Box>
      <div className="h-9 w-full max-w-[185px]">
        <Paragraph3
          fontWeight="500"
          textColor="#1A202C"
          lineHeight="20px"
          className="h-[20px] text-ellipsis overflow-hidden whitespace-nowrap"
        >
          {businessName || "No Business Name"}
        </Paragraph3>
        <Paragraph4
          textColor="#718096"
          lineHeight="16px"
          className="h-4 text-ellipsis overflow-hidden whitespace-nowrap"
        >
          {business.email}
        </Paragraph4>
      </div>
    </Box>
  );
};
